import { httpGet, uploadFiles, httpDelete } from './api.service';
import { UploadImageRequest } from '../requestModels/uploadImageRequest';
import { ImageUploadResponse } from '../types/Images';
import { AxiosResponse } from 'axios';

const getImages = async (request: UploadImageRequest): Promise<string[]> => {
  return await httpGet<string[]>(`api/image/${request.resourceType}/${request.subjectId}`);
};

const uploadImages = async (request: UploadImageRequest, onUploadProgress: (progressEvent) => void): Promise<ImageUploadResponse> => {
  const response: AxiosResponse = await uploadFiles(`api/image/upload`, request, onUploadProgress);

  if (response && response.status === 200) {
    const data: ImageUploadResponse = response.data;
    return data;
  } else {
    throw new Error('Something went wrong while uploading these images...');
  }
};

const deleteImage = async (id: string): Promise<boolean> => {
  return await httpDelete(`api/image/${id}`);
};

export { getImages, uploadImages, deleteImage };
